import React from 'react';
import { formatContent } from '../../../utils/contentParser';

const ReportContent = ({ content }) => {
  return (
    <div className="report-content">
      {formatContent(content)}
    </div>
  );
};

export default ReportContent;
